import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageToUpdate } from "../types";

export const bulkUpdatePagesListByBrand = async (
  brandId: string,
  pages: PageToUpdate[],
): Promise<void> => {
  const batch = writeBatch(db);

  pages.forEach((page) => {
    const docRef = doc(db, `brands/${brandId}/pages/${page.id}`);
    batch.update(docRef, page);
  });

  await batch.commit();
};
